import { personFrag } from './person.types';
import { serviceUserFrag } from '../../../../services/types/user.types';
import { connectedProcedureFrag } from './medication.types';

export const folderMedicationFrag = `
    id
    customMedication
    customMedicationName
    dosing {
        afternoon
        evening
        forenoon
        hours
        morning
        night
        noon
    }
    dosingNote
    dosingPeriod {
        custom
        days
        hours
    }
    from
    internalNote
    medicationCode
    packageTo
    to
    connectedProcedures {
        ${connectedProcedureFrag}
    }
    active
    prescribedBy
`;

export const epicrisisFrag = `
    id
    data
    createdAt
`;

export const folderFrag = `
    id
    status
    useDownPayment
    closedAt
    epicrises {
        ${epicrisisFrag}
    }
    folderMedications {
        ${folderMedicationFrag}
    }
    person {
        ${personFrag}
    }
    keyWorkerId
    keyWorker {
        id
        name
        surname
        titleBeforeName
        titleAfterName
    }
    workplaces {
        id
        name
        workplaceId
        dateFrom
        dateTo
        workplaceDeleted
    }
    serviceId
    activeGroups {
        id
        primary
        group {
            id
            name
            type
        }
    }
    workgroup {
        id
        serviceWorkgroupId
        serviceWorkgroupName
        serviceWorkgroupColor
        validFrom
        validTo
    }
    relatedFolders {
        id
        serviceId
    }
    activePersons {
        id
        personId
        isMain
        person {
            id
            name
            surname
            titleBeforeName
            titleAfterName
            birthSurname
            alias
        }
    }
`;

export const folderGridItemFrag = `
    id
    personId
    serviceId
    status
    lastFormData {
        data
        folderForm {
            form {
                uniqueIdentifier
            }
        }
    }
    contacts {
        id
        active
        primary
        user {
            email
            name
            surname
            titleBeforeName
            titleAfterName
            phone
            mobile
        }
    }
    person {
        ${personFrag}
    }
    services {
        id
        name
    }
    serviceInfo {
        id
        name
    }
    workplaces {
        id
        name
        workplaceId
        dateFrom
        dateTo
    }
    createdAt
    closedAt
    activeVouchers {
        id
        doctor {
            ${serviceUserFrag}
        }
        primaryDiagnosis {
            code
            name
        }
    }
    activeMedications {
        ${folderMedicationFrag}
    }
    lastServiceRecord {
        workData {
            ... on WorkDataServiceRecordObject {
                note
            }
        }
    }
    lastWorks {
        dateFrom
        workType
        workData {
            ... on WorkDataVisitObject {
                note
            }
            ... on WorkDataUnrealizedVisitObject {
                note
            }
            ... on WorkDataServiceRecordObject {
                note
            }
            ... on WorkDataResiduaryCareObject {
                data
            }
            ... on WorkDataInterventionObject {
                note
            }
            ... on WorkDataSpecialistRecordObject {
                note
            }
            ... on WorkDataDoctorRecordObject {
                note
            }
        }
    }
    notes {
        id
        note
        date
    }
    activeGroups {
        id
        primary
        group {
          id
          name
          type
          __typename
        }
        __typename
      }
`;
